// components/Dashboard.jsx
import React from 'react';
import { motion } from 'framer-motion';

const Dashboard = () => {
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const item = {
    hidden: { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0 }
  };

  return (
    <motion.div 
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="p-8"
    >
      <h1 className="text-3xl font-bold text-gray-800 mb-8">Dashboard</h1>
      
      <motion.div 
        className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8"
        variants={container}
        initial="hidden"
        animate="show"
      >
        {/* Total Users */}
        <motion.div 
          className="bg-white rounded-lg shadow p-6"
          variants={item}
        >
          <div className="flex items-center mb-4">
            <div className="p-2 bg-blue-100 rounded-full mr-3">
              <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
              </svg>
            </div>
            <span className="text-gray-600">Total Users</span>
          </div>
          <p className="text-4xl font-bold">0</p>
        </motion.div>

        {/* Total Events Posted */}
        <motion.div 
          className="bg-white rounded-lg shadow p-6"
          variants={item}
        >
          <div className="flex items-center mb-4">
            <div className="p-2 bg-indigo-100 rounded-full mr-3">
              <svg className="w-5 h-5 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
              </svg>
            </div>
            <span className="text-gray-600">Total Event Posted</span>
          </div>
          <p className="text-4xl font-bold">0</p>
        </motion.div>

        {/* Total Wallet Volume */}
        <motion.div 
          className="bg-white rounded-lg shadow p-6"
          variants={item}
        >
          <div className="flex items-center mb-4">
            <div className="p-2 bg-green-100 rounded-full mr-3">
              <svg className="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"></path>
              </svg>
            </div>
            <span className="text-gray-600">Total Wallet Volume</span>
          </div>
          <p className="text-4xl font-bold">8</p>
        </motion.div>

        {/* Total Tickets Sold */}
        <motion.div 
          className="bg-white rounded-lg shadow p-6"
          variants={item}
        >
          <div className="flex items-center mb-4">
            <div className="p-2 bg-purple-100 rounded-full mr-3">
              <svg className="w-5 h-5 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z"></path>
              </svg>
            </div>
            <span className="text-gray-600">Total Tickets Sold</span>
          </div>
          <p className="text-4xl font-bold">0</p>
        </motion.div>

        {/* Pending Refunds */}
        <motion.div 
          className="bg-white rounded-lg shadow p-6"
          variants={item}
        >
          <div className="flex items-center mb-4">
            <div className="p-2 bg-yellow-100 rounded-full mr-3">
              <svg className="w-5 h-5 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
            </div>
            <span className="text-gray-600">Pending Refunds</span>
          </div>
          <p className="text-4xl font-bold">0</p>
        </motion.div>

        {/* Dispute Alerts */}
        <motion.div 
          className="bg-white rounded-lg shadow p-6"
          variants={item}
        >
          <div className="flex items-center mb-4">
            <div className="p-2 bg-red-100 rounded-full mr-3">
              <svg className="w-5 h-5 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
              </svg>
            </div>
            <span className="text-gray-600">Dispute Alerts</span>
          </div>
          <p className="text-4xl font-bold">8</p>
        </motion.div>
      </motion.div>

      {/* Search Bar */}
      <div className="relative mb-8">
        <input 
          type="text" 
          placeholder="Search" 
          className="w-full p-4 pl-12 rounded-full border border-gray-300 shadow-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
        />
        <div className="absolute left-4 top-1/2 transform -translate-y-1/2">
          <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
          </svg>
        </div>
      </div>

      {/* Recent Activity Feed */}
      <motion.div 
        className="bg-white rounded-lg shadow overflow-hidden"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3 }}
      >
        <div className="p-6 border-b border-gray-200">
          <h2 className="text-xl font-semibold text-gray-800">Recent activity feed</h2>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">No</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Time</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Action Type</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">User</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Details</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              <tr>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">1.</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">2:15 PM</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Wallet funded</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Favour Favour</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">₦5,000 via paystack</td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">Success</span>
                </td>
              </tr>
              <tr>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">1.</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">2:15 PM</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Event Created</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Sarah</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">Tech Connect 202s</td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">Approved</span>
                </td>
              </tr>
              <tr>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">1.</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">2:15 PM</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Refund Request</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Favour Favour</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">₦5,000 for Art Night</td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-yellow-100 text-yellow-800">Pending</span>
                </td>
              </tr>
              <tr>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">1.</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">2:15 PM</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Ticket Purchase</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Favour Favour</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">2 Ticket for Lagos food</td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">Paid</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default Dashboard;